import { connect } from 'react-redux';
import { branch, compose, renderComponent, withProps } from 'recompose';
import * as SessionSelectors from '../entities/Session/selectors';
import LoadingScreen from '../LoadingScreen/LoadingScreen';

const ensureInitialized = compose(
  connect(
    state => ({
      isInitialized: SessionSelectors.initialized(state),
    }),
  ),
  branch(
    props => !props.isInitialized,
    compose(
      withProps(() => ({ isLoading: true })),
      renderComponent(LoadingScreen),
    ),
  ),
);

export default ensureInitialized;
